<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header 
    [currentUser]="currentUser"
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Dashboard Content (Sidebar + Main) -->
  <div class="dashboard-content">
    <!-- Sidebar -->
    <app-staff-nav 
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (mobileMenuClose)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Main Content -->
    <main class="dashboard-main">
      <!-- Management Dashboard View -->
      <div class="main-content" *ngIf="currentView === 'dashboard' && currentData">
        <!-- Header with Year Filter -->
        <div class="content-header">
          <div class="header-left">
            <h2 class="page-title">แดชบอร์ดผู้บริหาร</h2>
            <p class="page-subtitle">ภาพรวมสถิติและข้อมูลสมาคมผู้ประเมินมูลค่าทรัพย์สินแห่งประเทศไทย</p>
          </div>
          <div class="header-right">
            <div class="year-filter">
              <label for="yearSelect">เลือกปี:</label>
              <select id="yearSelect" [(ngModel)]="selectedYear" (change)="onYearChange()" class="year-select">
                <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- User Story 1: VAT Membership & Organization Overview -->
        <section class="dashboard-section">
          <h3 class="section-title">
            <i class="bi bi-people-fill"></i>
            ภาพรวมสมาชิก VAT และหน่วยงาน
          </h3>

          <div class="chart-grid">
            <!-- Membership Overview -->
            <div class="chart-card">
              <div class="card-header">
                <h4>สมาชิก VAT</h4>
                <span class="total-badge">{{ formatNumber(currentData.membership.total) }} คน</span>
              </div>
              <div class="chart-body">
                <div class="chart-container">
                  <canvas baseChart
                    [data]="membershipPieChartData"
                    [type]="membershipPieChartType"
                    [options]="membershipPieChartOptions">
                  </canvas>
                </div>
              </div>
            </div>

            <!-- Membership Revenue -->
            <div class="chart-card">
              <div class="card-header">
                <h4>รายได้จากสมาชิก (ปี {{ selectedYear }})</h4>
              </div>
              <div class="card-body">
                <div class="revenue-item">
                  <span class="revenue-label">รายได้จากการสมัครสมาชิกใหม่</span>
                  <span class="revenue-value success">{{ formatCurrency(currentData.membership.revenue.newRegistration) }}</span>
                </div>
                <div class="revenue-item">
                  <span class="revenue-label">รายได้จากการต่ออายุ</span>
                  <span class="revenue-value primary">{{ formatCurrency(currentData.membership.revenue.renewal) }}</span>
                </div>
                <div class="revenue-total">
                  <span class="revenue-label"><strong>รายได้รวม</strong></span>
                  <span class="revenue-value total">{{ formatCurrency(currentData.membership.revenue.newRegistration + currentData.membership.revenue.renewal) }}</span>
                </div>
              </div>
            </div>

            <!-- Organization Overview -->
            <div class="chart-card">
              <div class="card-header">
                <h4>หน่วยงาน</h4>
                <span class="total-badge">{{ formatNumber(currentData.organization.total) }} แห่ง</span>
              </div>
              <div class="chart-body">
                <div class="chart-container">
                  <canvas baseChart
                    [data]="organizationPieChartData"
                    [type]="organizationPieChartType"
                    [options]="organizationPieChartOptions">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- User Story 2: Principal Appraiser Analysis & Revenue -->
        <section class="dashboard-section">
          <h3 class="section-title">
            <i class="bi bi-award-fill"></i>
            ผู้ประเมินหลักและรายได้
          </h3>

          <div class="chart-grid">
            <!-- Appraiser Overview Stats -->
            <div class="chart-card">
              <div class="card-header">
                <h4>สถิติผู้ประเมินหลัก</h4>
              </div>
              <div class="card-body">
                <div class="stat-row">
                  <div class="stat-item success">
                    <div class="stat-icon-small">
                      <i class="bi bi-person-check-fill"></i>
                    </div>
                    <div class="stat-info">
                      <span class="stat-label">มีบัตรผู้ประเมินหลัก</span>
                      <span class="stat-value">{{ formatNumber(currentData.appraiser.totalWithCard) }}</span>
                    </div>
                  </div>
                  <div class="stat-item warning">
                    <div class="stat-icon-small">
                      <i class="bi bi-person-x-fill"></i>
                    </div>
                    <div class="stat-info">
                      <span class="stat-label">ไม่มีบัตรผู้ประเมินหลัก</span>
                      <span class="stat-value">{{ formatNumber(currentData.appraiser.totalWithoutCard) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Appraiser Type Distribution -->
            <div class="chart-card">
              <div class="card-header">
                <h4>ประเภทบัตรผู้ประเมินหลัก</h4>
              </div>
              <div class="chart-body">
                <div class="chart-container">
                  <canvas baseChart
                    [data]="appraiserTypePieChartData"
                    [type]="appraiserTypePieChartType"
                    [options]="appraiserTypePieChartOptions">
                  </canvas>
                </div>
              </div>
            </div>

            <!-- Appraiser Revenue Overview -->
            <div class="chart-card">
              <div class="card-header">
                <h4>รายได้จากบัตรผู้ประเมินหลัก</h4>
                <span class="total-badge">{{ formatCurrency(currentData.appraiser.revenue.total) }}</span>
              </div>
              <div class="chart-body">
                <div class="chart-container">
                  <canvas baseChart
                    [data]="appraiserRevenuePieChartData"
                    [type]="appraiserRevenuePieChartType"
                    [options]="appraiserRevenuePieChartOptions">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- User Story 3: Seminar & CPD Performance Tracking -->
        <section class="dashboard-section">
          <h3 class="section-title">
            <i class="bi bi-book-fill"></i>
            สัมมนาและ CPD
          </h3>

          <!-- Summary Stats -->
          <div class="summary-stats">
            <div class="summary-card primary">
              <div class="summary-icon">
                <i class="bi bi-journal-bookmark-fill"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">คอร์สสัมมนาทั้งหมด (ปี {{ selectedYear }})</span>
                <span class="summary-value">{{ formatNumber(currentData.course.totalCourses) }}</span>
              </div>
            </div>
            <div class="summary-card success">
              <div class="summary-icon">
                <i class="bi bi-clock-fill"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">จำนวน CPD รวม (ปี {{ selectedYear }})</span>
                <span class="summary-value">{{ formatNumber(currentData.course.totalCPD) }}</span>
              </div>
            </div>
            <div class="summary-card warning">
              <div class="summary-icon">
                <i class="bi bi-cash-stack"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">รายได้จากสัมมนา (ปี {{ selectedYear }})</span>
                <span class="summary-value">{{ formatCurrency(currentData.course.revenue) }}</span>
              </div>
            </div>
          </div>

          <!-- Historical Charts -->
          <div class="chart-grid-2">
            <!-- Course & CPD Historical Chart -->
            <div class="chart-card large">
              <div class="card-header">
                <h4>จำนวนคอร์สและ CPD ย้อนหลัง 5 ปี (ปี 2564-2569)</h4>
              </div>
              <div class="chart-body">
                <div class="chart-container-large">
                  <canvas baseChart
                    [data]="courseBarChartData"
                    [type]="courseBarChartType"
                    [options]="courseBarChartOptions">
                  </canvas>
                </div>
              </div>
            </div>

            <!-- Course Revenue Historical Chart -->
            <div class="chart-card large">
              <div class="card-header">
                <h4>รายได้จากสัมมนาย้อนหลัง 5 ปี (ปี 2564-2569)</h4>
              </div>
              <div class="chart-body">
                <div class="chart-container-large">
                  <canvas baseChart
                    [data]="courseRevenueBarChartData"
                    [type]="courseRevenueBarChartType"
                    [options]="courseRevenueBarChartOptions">
                  </canvas>
                </div>
              </div>
            </div>
          </div>

          <!-- Top 10 Popular Courses -->
          <div class="chart-card full-width">
            <div class="card-header">
              <h4>
                <i class="bi bi-trophy-fill"></i>
                Top 10 คอร์สยอดนิยม (ตั้งแต่ปี 2564)
              </h4>
            </div>
            <div class="table-responsive">
              <table class="popular-courses-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ชื่อคอร์ส</th>
                    <th>CPD</th>
                    <th>วันที่</th>
                    <th>รูปแบบ</th>
                    <th>ผู้เข้าอบรม</th>
                    <th>รายได้</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let course of popularCourses; let i = index">
                    <td>
                      <span class="rank-badge" [class.top-3]="i < 3">{{ i + 1 }}</span>
                    </td>
                    <td class="course-name">{{ course.courseName }}</td>
                    <td><span class="cpd-badge">{{ course.cpd }} ชม.</span></td>
                    <td>{{ course.date }}</td>
                    <td>
                      <span class="format-badge" [ngClass]="{
                        'format-onsite': course.format === 'Onsite',
                        'format-online': course.format === 'Online',
                        'format-hybrid': course.format === 'Hybrid'
                      }">{{ course.format }}</span>
                    </td>
                    <td>{{ formatNumber(course.participants) }} คน</td>
                    <td class="revenue-cell">{{ formatCurrency(course.revenue) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <!-- User Story 4: Appraiser Examination Statistics -->
        <section class="dashboard-section">
          <h3 class="section-title">
            <i class="bi bi-clipboard-check-fill"></i>
            การจัดสอบผู้ประเมินหลัก
          </h3>

          <!-- Exam Summary -->
          <div class="summary-stats">
            <div class="summary-card primary">
              <div class="summary-icon">
                <i class="bi bi-calendar-event-fill"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">จำนวนครั้งที่จัดสอบ (ปี {{ selectedYear }})</span>
                <span class="summary-value">{{ formatNumber(currentData.exam.totalExams) }}</span>
              </div>
            </div>
          </div>

          <div class="chart-grid-2">
            <!-- Exam Historical Chart -->
            <div class="chart-card large">
              <div class="card-header">
                <h4>จำนวนการจัดสอบย้อนหลัง 5 ปี (ปี 2564-2569)</h4>
              </div>
              <div class="chart-body">
                <div class="chart-container-large">
                  <canvas baseChart
                    [data]="examBarChartData"
                    [type]="examBarChartType"
                    [options]="examBarChartOptions">
                  </canvas>
                </div>
              </div>
            </div>

            <!-- Exam Type Distribution -->
            <div class="chart-card">
              <div class="card-header">
                <h4>การจัดสอบตามประเภท (ปี {{ selectedYear }})</h4>
              </div>
              <div class="chart-body">
                <div class="chart-container">
                  <canvas baseChart
                    [data]="examTypePieChartData"
                    [type]="examTypePieChartType"
                    [options]="examTypePieChartOptions">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- Courses View (Placeholder) -->
      <div class="view-content" *ngIf="currentView === 'courses'">
        <div class="placeholder-content">
          <div class="placeholder-header">
            <h2 class="page-title">จัดการหลักสูตร</h2>
            <p class="page-subtitle">ระบบจัดการหลักสูตรการศึกษา</p>
          </div>
          <div class="placeholder-body">
            <div class="placeholder-card">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
              </svg>
              <h3>จัดการหลักสูตร</h3>
              <p>ฟีเจอร์นี้กำลังพัฒนา</p>
              <button class="back-btn" (click)="navigateToDashboard()">กลับไปแดชบอร์ด</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reports View (Placeholder) -->
      <div class="view-content" *ngIf="currentView === 'reports'">
        <div class="placeholder-content">
          <div class="placeholder-header">
            <h2 class="page-title">รายงาน</h2>
            <p class="page-subtitle">ระบบรายงานและสถิติ</p>
          </div>
          <div class="placeholder-body">
            <div class="placeholder-card">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14,2 14,8 20,8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </svg>
              <h3>รายงาน</h3>
              <p>ฟีเจอร์นี้กำลังพัฒนา</p>
              <button class="back-btn" (click)="navigateToDashboard()">กลับไปแดชบอร์ด</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Settings View (Placeholder) -->
      <div class="view-content" *ngIf="currentView === 'settings'">
        <div class="placeholder-content">
          <div class="placeholder-header">
            <h2 class="page-title">การตั้งค่า</h2>
            <p class="page-subtitle">ระบบการตั้งค่าและการกำหนดค่า</p>
          </div>
          <div class="placeholder-body">
            <div class="placeholder-card">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
              <h3>การตั้งค่า</h3>
              <p>ฟีเจอร์นี้กำลังพัฒนา</p>
              <button class="back-btn" (click)="navigateToDashboard()">กลับไปแดชบอร์ด</button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div> 